import AlterarEmail from './AlterarEmail.vue';

export default {
  path: 'alterar-email',
  component: AlterarEmail,
  name: 'alterar-email',
  meta: { auth: true },
}



// WEBPACK FOOTER //
// ./FrontEnd/modulos/alterar-email/rotas.js